import { categoryMenuApi } from '../../../api/category/categoryMenuApi';
import { ICategoryMenu } from '../../../model/respone/category/ICategoryMenu';
import { IBaseRespone } from '../../../model/respone/IBaseRespone';
import { rootActions } from '../../actions/rootActions';
import { eCategoryMenuActionTypeIds, ICategoryMenuActions } from './../../action-types/category/ICategoryMenuActionType';
import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
const mainAction = rootActions.category.categoryMenu;
export function* categoryMenuSaga(): any {
    yield takeLatest(eCategoryMenuActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eCategoryMenuActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eCategoryMenuActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: ICategoryMenuActions): any {
    const res: IBaseRespone = yield call(categoryMenuApi.SelectAll)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveWorker(action: ICategoryMenuActions): any {
    let res: IBaseRespone;
    const categoryMenu = action.payload as ICategoryMenu;
    if (categoryMenu.id > 0) {
        res = yield call(categoryMenuApi.Update, categoryMenu)
    } else {
        res = yield call(categoryMenuApi.Insert, categoryMenu)
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data))
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
    }
}

function* deleteWorker(action: ICategoryMenuActions): any {
    const res: IBaseRespone = yield call(categoryMenuApi.Delete, action.payload as number)
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data))
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"))
    }
}

